export const widgetListSettings = [
  {
    order: 1,
    colspan: 6,
    widgetId: "inspectionSummaryWidget",
    settings: [{ code: "inspectionSummary", entity: "inspection", dataType: "summary", filters: ["lines"] }],
  },
  {
    order: 3,
    colspan: 6,
    widgetId: "workOrderStatusSummaryWidget",
    settings: [{ code: "maintenanceSummary", entity: "maintenance", dataType: "summary", filters: ["lines"] }],
  },
  {
    order: 4,
    colspan: 6,
    widgetId: "inspectionsList",
    settings: [{ code: "inspectionList", entity: "inspection", dataType: "list", filters: ["lines"] }],
  },
  {
    order: 5,
    colspan: 6,
    widgetId: "maintenanceList",
    settings: [{ code: "maintenanceList", entity: "maintenance", dataType: "list", filters: ["lines"] }],
  },
  {
    order: 6,
    colspan: 6,
    widgetId: "BarGraphSummaryWidget",
    settings: [
      { code: "inspectionSummary", entity: "inspection", dataType: "summary", filters: ["lines"] },
      { code: "maintenanceSummary", entity: "maintenance", dataType: "summary", filters: ["lines"] },
      { code: "executionSummary", entity: "execution", dataType: "summary", filters: ["lines"] },
    ],
  },
  {
    order: 7,
    colspan: 6,
    widgetId: "executionsList",
    settings: [{ code: "executionList", entity: "execution", dataType: "list", filters: ["lines"] }],
  },
];



// WEBPACK FOOTER //
// ./src/components/NewDashboard/widgetSettings.js